import React from "react";
import "../Loading/loading.css";

export default function Loading() {
  return <div className="loading"></div>;
}
